import React, { useEffect, useState } from 'react';
import './OdemeEkleModal.css';

const ODEME_YONTEMLERI = [
  { value: 'Nakit', label: 'Nakit' },
  { value: 'HavaleEFT', label: 'Havale/EFT' },
  { value: 'KrediKarti', label: 'Kredi Kartı' },
  { value: 'CekSenet', label: 'Çek/Senet' },
];

const OdemeEkleModal = ({ type = 'odeme', teknikServisAdi, onClose, onSuccess, isSubmitting = false }) => {
  const [odemeYontemi, setOdemeYontemi] = useState('Nakit');
  const [odemeNotu, setOdemeNotu] = useState('');
  const [tutar, setTutar] = useState('');
  const [error, setError] = useState('');

  const isOdeme = type === 'odeme';
  const title = isOdeme ? 'Ödeme Ekle' : 'Tahsilat Ekle';
  const icon = isOdeme ? 'fa-money-bill-wave' : 'fa-hand-holding-usd';
  const hint = isOdeme
    ? 'Teknik servise yapılan ödeme cari bakiyeyi artırır.'
    : 'Teknik servisten alınan tahsilat cari bakiyeyi azaltır.';

  useEffect(() => {
    setOdemeYontemi('Nakit');
    setOdemeNotu('');
    setTutar('');
    setError('');
  }, [type, teknikServisAdi]);

  const parseTutar = (raw) => {
    const normalized = String(raw ?? '').trim().replace(/\./g, '').replace(',', '.');
    const n = parseFloat(normalized);
    return Number.isFinite(n) && n > 0 ? n : null;
  };

  const handleSubmit = (e) => {
    e?.preventDefault?.();
    const tutarNum = parseTutar(tutar);
    if (tutarNum == null) {
      setError('Geçerli bir tutar girin');
      return;
    }
    setError('');
    onSuccess({ odemeYontemi, odemeNotu: odemeNotu.trim() || undefined, tutar: tutarNum });
  };

  return (
    <div className="modal-overlay odeme-ekle-modal" onClick={onClose} role="presentation">
      <div
        className="modal-content odeme-ekle-modal__panel"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="odeme-ekle-modal-title">
        <div className="modal-header odeme-ekle-modal__header">
          <h2 id="odeme-ekle-modal-title">
            <span className={`odeme-ekle-modal__header-icon ${isOdeme ? 'is-odeme' : 'is-tahsilat'}`}>
              <i className={`fas ${icon}`} aria-hidden="true" />
            </span>
            {title}
          </h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="odeme-ekle-modal__context">
              <span className="odeme-ekle-modal__context-label">Teknik Servis</span>
              <div className="odeme-ekle-modal__context-name">{teknikServisAdi || '—'}</div>
              <p className="odeme-ekle-modal__hint">{hint}</p>
            </div>

            <label className="form-field">
              <span>Ödeme yöntemi *</span>
              <select
                value={odemeYontemi}
                onChange={(e) => setOdemeYontemi(e.target.value)}
                disabled={isSubmitting}>
                {ODEME_YONTEMLERI.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </label>

            <label className="form-field">
              <span>Tutar *</span>
              <div className="odeme-ekle-modal__tutar-wrap">
                <input
                  type="text"
                  inputMode="decimal"
                  value={tutar}
                  onChange={(e) => setTutar(e.target.value)}
                  placeholder="0,00"
                  disabled={isSubmitting}
                  autoFocus
                />
                <span className="odeme-ekle-modal__tutar-suffix">₺</span>
              </div>
            </label>

            <label className="form-field">
              <span>Not (opsiyonel)</span>
              <textarea
                value={odemeNotu}
                onChange={(e) => setOdemeNotu(e.target.value)}
                placeholder="IBAN, çek no, açıklama…"
                disabled={isSubmitting}
                rows={3}
              />
            </label>

            {error ? (
              <div className="odeme-ekle-modal__error" role="alert">
                {error}
              </div>
            ) : null}
          </div>

          <div className="odeme-ekle-modal__footer">
            <button type="button" className="secondary-btn" onClick={onClose} disabled={isSubmitting}>
              İptal
            </button>
            <button
              type="submit"
              className={`primary-btn odeme-ekle-modal__submit ${isOdeme ? 'is-odeme' : 'is-tahsilat'}`}
              disabled={isSubmitting}>
              {isSubmitting ? 'Kaydediliyor…' : isOdeme ? 'Ödemeyi Kaydet' : 'Tahsilatı Kaydet'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OdemeEkleModal;
